import { FaHammer, FaHeart, FaCalendarAlt, FaMapMarkedAlt } from 'react-icons/fa';

const counter = [
  {
    id: 1,
    icon: <FaHammer />, // Hammer icon
    title: 'Woodwork Projects',
    count: '20000',
  },
  {
    id: 2,
    icon: <FaHeart />, // Heart icon
    title: 'Happy Clients',
    count: '30000',
  },
  {
    id: 3,
    icon: <FaCalendarAlt />, // Calendar icon
    title: 'Years of Experience',
    count: '25',
  },
  {
    id: 4,
    icon: <FaMapMarkedAlt />, // Map Marked icon
    title: 'Service Locations',
    count: '100',
  },
];

export default counter;